(function () {
    const $ = require('jquery');
    $('.jsFormRecaptchaButton').on('click', function (e) {
        let formParent = $(e.currentTarget).closest('form');
        if (!formParent.is(':valid')) {
            return;
        }

        e.preventDefault();

        const action = $(e.currentTarget).data('recaptcha-action');
        grecaptcha.ready(() => {
            grecaptcha.execute(window.RECAPTCHA_SITEKEY, { action: action, })
                .then((token) => {
                    const responseFormField = document.createElement('input');
                    responseFormField.type = 'hidden';
                    responseFormField.name = 'g-recaptcha-response';
                    responseFormField.value = token;

                    formParent.prepend(responseFormField);
                    formParent.trigger('submit');
                });
        });
    });
})();
